module.exports = __webpack_public_path__ + "static/media/zoom-minus-fill.9be9fef2.svg";